import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Form, Upload, Tooltip, Icon, message, notification } from "antd";

import { validateType } from "../../utils/validateFiles";
import { FILE_SIZE } from "../../utils/constants";

import DownloadAnexo from "./DownloadAnexo";

const { Dragger } = Upload;
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const UploadAnexo = ({
    required,
    titulo,
    getFieldDecorator,
    fileList,
    setFileList,
    form,
    maxFileSize = FILE_SIZE.TWENTY_FIVE_MB, // Default 25MB
    temViewer = false,
    temExcluir = false
}) => {
    const [docGerado, setDocGerado] = useState("");
    const [nomeDoc, setNomeDoc] = useState("");

    const handleValidation = value => {
        if (value.size > maxFileSize.value) {
            openNotificationWithIcon("error", "Erro", `O arquivo deve ter no máximo ${maxFileSize.label}!`);
            return false;
        }

        if (value.type !== "application/pdf") {
            openNotificationWithIcon("error", "Erro", "Formato de arquivo inválido! Apenas arquivos .pdf são aceites.");
            return false;
        }
        return true;
    };

    const props = {
        accept: ".pdf",
        multiple: false,
        onRemove: file => {
            form.resetFields("ficheiro");
            setFileList(fileList => {
                const index = fileList.indexOf(file);
                const newFileList = fileList.slice();
                newFileList.splice(index, 1);

                return newFileList;
            });
        },
        defaultFileList: fileList,
        beforeUpload: file => {
            if (!handleValidation(file)) {
                return false;
            }
            setFileList([file]);

            return false;
        },
        fileList
    };

    useEffect(() => {
        var file = fileList[0];

        if (file) {
            const blob = new Blob([file]);
            const fileUrl = URL.createObjectURL(blob);
            setDocGerado(fileUrl);
            setNomeDoc(file.name);
        } else {
            setDocGerado("");
            setNomeDoc("");
        }
    }, [fileList]);

    return (
        <Form.Item label={titulo}>
            <div className="anexos">
                <Dragger {...props} disabled={docGerado} showUploadList={false}>
                    <p className="ant-upload-drag-icon">
                        <i className="fas fa-upload" />
                    </p>
                    <p className="ant-upload-text">
                        Adicionar anexo
                        <Tooltip title="Formatos válidos: .pdf">
                            <Icon type="question-circle-o" />
                        </Tooltip>
                    </p>
                    <p className="ant-upload-hint">Limite de {maxFileSize.label} por upload</p>
                </Dragger>
            </div>
            {docGerado && (
                <DownloadAnexo
                    docGerado={docGerado}
                    setDocGerado={setDocGerado}
                    nomeDocGerado={nomeDoc}
                    setFileList={setFileList}
                    temViewer={temViewer}
                    temExcluir={temExcluir}
                />
            )}
        </Form.Item>
    );
};

export default UploadAnexo;
